import { Link } from "react-router-dom";
import React, { useContext } from 'react';
import { ThemeContext } from '../../components/molecules/Nav';

const ENTRANCE_COLOR = '#f59e0b'; // amber
const EXIT_COLOR = '#3b82f6';     // blue

export default function OfficeCard({ locationData, data }) {
  const [theme] = useContext(ThemeContext);

  const entrances = data?.totalCount || 0;
  const exits = data?.totalCountOut || 0;
  const inside = Math.max(0, entrances - exits);
  const combined = entrances + exits;
  const inShare = combined ? (entrances / combined) * 100 : 50;
  const outShare = 100 - inShare;

  const cardBg = theme === 'light'
    ? 'linear-gradient(145deg, #ffffff, #f5f5f5)'
    : 'linear-gradient(145deg, #2a2a2a, #1a1a1a)';
  const baseShadow = theme === 'light'
    ? '0 4px 6px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.1)'
    : '0 4px 6px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.3)';
  const hoverShadow = theme === 'light'
    ? '0 6px 12px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.08)'
    : '0 6px 12px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.2)';
  const divider = theme === 'light'
    ? 'linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.05) 100%)'
    : 'linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)';
  const trackBg = theme === 'light' ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.12)';

  return (
    <div className="fw-bold mb-4" style={{ width: '100%', maxWidth: '400px', minWidth: '300px' }}>
      <Link
        to={`../locations/office/${locationData.name.replace(/ /g, '-').toLowerCase()}`}
        state={{ id: locationData.id, currentLocation: locationData }}
        className="office-card d-block panel-2 position-relative"
        style={{
          borderRadius: "16px",
          textDecoration: "none",
          color: "inherit",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          padding: "1.5rem",
          background: cardBg,
          boxShadow: baseShadow,
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = hoverShadow;
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = baseShadow;
        }}
      >
        {/* Header */}
        <div className="d-flex align-items-center mb-3">
          <img
            src={require(`../../clients/${locationData.logoPath}`)}
            alt="logo"
            style={{
              width: "70px", height: "70px", objectFit: "contain",
              marginRight: "1.25rem", transform: 'scale(1.15)'
            }}
          />
          <div className="h3 mb-0" style={{ fontWeight: 'bold' }}>{locationData.name}</div>
        </div>

        <div className="my-2" style={{ height: "1px", background: divider }} />

        {/* In / Out split */}
        <div style={{ minHeight: "160px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "0.75rem" }}>
          <div className="d-flex justify-content-between align-items-baseline">
            <span style={{ color: ENTRANCE_COLOR, fontSize: "0.9rem" }}>Entrances</span>
            <span style={{ color: ENTRANCE_COLOR, fontSize: "2.4rem", fontWeight: 700 }}>
              {entrances.toLocaleString()}
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-baseline">
            <span style={{ color: EXIT_COLOR, fontSize: "0.9rem" }}>Exits</span>
            <span style={{ color: EXIT_COLOR, fontSize: "2.4rem", fontWeight: 700 }}>
              {exits.toLocaleString()}
            </span>
          </div>

          {/* Proportion bar: amber (in) vs blue (out) */}
          <div style={{ display: "flex", height: 8, borderRadius: 4, overflow: "hidden", background: trackBg }}>
            <div style={{ width: `${inShare}%`, background: ENTRANCE_COLOR, transition: "width 0.3s ease" }} />
            <div style={{ width: `${outShare}%`, background: EXIT_COLOR, transition: "width 0.3s ease" }} />
          </div>

          <div className="text-muted text-center" style={{ fontSize: "0.85rem" }}>
            {inside.toLocaleString()} currently inside (net)
          </div>
        </div>
      </Link>
    </div>
  );
}